require('./bootstrap');

// Import Tailwind CSS
import '../css/admin-app.css';

// Import modules...
import { createApp, h } from 'vue';
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue3';
import { Link } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

// Make route function available globally for webpack builds
window.route = window.route || function() { return ''; };

// Pre-load all components using require.context to avoid code splitting
const pages = require.context('./Pages', true, /\.vue$/i);
const pageComponents = {};

pages.keys().forEach(path => {
    const componentName = path.replace(/^\.\//, '').replace(/\.vue$/, '');
    pageComponents[componentName] = pages(path).default || pages(path);
});

const el = document.getElementById('app');

const app = createApp({
    render: () =>
        h(InertiaApp, {
            initialPage: JSON.parse(el.dataset.page),
            resolveComponent: (name) => {
                // Return pre-loaded component instead of dynamic import
                return pageComponents[name] || null;
            },
        }),
});

// Register Inertia Link component globally
app.component('inertia-link', Link);

app.mixin({ 
        methods: { 
            route: window.route || function() { return ''; }
        } 
    })
    .use(InertiaPlugin)
    .mount(el);

InertiaProgress.init({ color: '#4B5563' });
